import Icon from './components/Icon';
import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Box, ThemeProvider, createTheme } from '@mui/material';
import Header from './components/app_bar/Header';
import LandingPage from './pages/LandingPage';
import ShareCodePage from './pages/ShareCodePage';
import CreativePrompts from './pages/CreativePrompts';
import WaitingLobbyPage from './pages/WaitingLobbyPage';
import { SimpleSetup, SimplePlay } from './pages/SimpleGame';
import ResultsPage from './pages/ResultsPage';
import ClosePhonePage from './pages/ClosePhonePage';
import GamePlayPage from './pages/GamePlayPage';
import Layout from './Layout';
import * as amplitude from '@amplitude/analytics-browser';
import CreativeGate from './components/CreativeGate';
import CreativeTV from './pages/CreativeTV';
import CreativeConnect from './pages/CreativeConnect';
import { CreativeDisplayProvider } from './components/CreativeDisplayBridge';

const theme = createTheme({
  palette: {
    primary: {
      main: '#191816',
    },
    secondary: {
      main: '#FFF9EF',
    },
    tertiary: {
      main: '#C93224',
    },
    quaternary: {
      main: '#F3E5D0',
    },
    fifth: {
      main: '#F3E5D0',
    },
  },
  typography: { fontFamily: '"DM Sans", sans-serif', button: { textTransform: 'none', fontWeight: 700 }, h5: { fontFamily: '"Barlow Condensed", Impact, sans-serif', fontWeight: 800 } },
  shape: { borderRadius: 4 },
  components: { MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { minHeight: 44 } } }, MuiTextField: { defaultProps: { variant: 'outlined' } } },
});

function App() {
  useEffect(() => {
    if (process.env.REACT_APP_AMPLITUDE_API_KEY) amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY, { defaultTracking: { sessions: true } });
  }, []);

  return (
    <ThemeProvider theme={theme}><CreativeDisplayProvider>
      <Header />
      <Box>
        <Routes>
          <Route path="/" element={<Layout><LandingPage /></Layout>} />

          <Route path="/simple-mode">
            <Route index element={<Navigate to="personalize" replace />} />
            <Route path="personalize" element={<Layout><SimpleSetup /></Layout>} />
            <Route path="play" element={<Layout><SimplePlay /></Layout>} />
          </Route>

          <Route path="/creative-mode/tv" element={<CreativeTV />} />
          <Route path="/creative-mode/connect" element={<Layout><CreativeConnect /></Layout>} />
          <Route path="/creative-mode/:urlGameCode" >
            <Route index element={<Navigate to="enter-prompts" replace />} />
            <Route path="share" element={<Layout><CreativeGate><ShareCodePage /></CreativeGate></Layout>} />
            <Route path="enter-prompts" element={<Layout><CreativePrompts /></Layout>} />
            <Route path="waiting-lobby" element={<Layout><CreativeGate><WaitingLobbyPage /></CreativeGate></Layout>} />
            <Route path="close-phone" element={<Layout><ClosePhonePage /></Layout>} />
            <Route path="play" element={<Layout><CreativeGate needsRound><GamePlayPage /></CreativeGate></Layout>} />
            <Route path="results" element={<Layout><CreativeGate needsRound><ResultsPage /></CreativeGate></Layout>} />
          </Route>

          <Route path="*" element={<Layout><div className="empty-state"><h1>This card got lost.</h1><a className="button dark" href="/">Back to the game <Icon name="arrow-right" /></a></div></Layout>} />
        </Routes>
      </Box>
    </CreativeDisplayProvider></ThemeProvider>
  );
}

export default App;
